import React from 'react'

import GeoUserInfoLine from './geoUserInfoLine'
import { Geo } from '../../store/commonTypes'
import { useTranslation } from 'react-i18next'
import SelectField from '../../components/form/SelectField'
import { Form, Field, Formik, FieldProps } from 'formik'
import { getPlural } from '../../utils/localizationHelpers'
import i18next from './../../i18next/index'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/rootReducer'
import { GeoState } from '../../store/geo/geoTypings'

interface Props {
    userList: Geo[]
    currentOrder: string
    setCurrentOrder: React.Dispatch<string>
}

const orderOptions = [
    { value: 'random', label: 'Not specified' },
    { value: 'online', label: 'Online' },
    { value: 'distance', label: 'Near to me' }
]

const GeoUserList: React.FunctionComponent<Props> = (props: Props) => {
    const { userList, currentOrder, setCurrentOrder } = props
    const formInitialValues = { sort: currentOrder }

    const { filters, hidePosition } = useSelector<RootState, GeoState>((state) => state.geo)
    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)

    const [t] = useTranslation()
    // @ts-ignore
    const userListOut = userList.map((item) => <GeoUserInfoLine user={item} key={item.id} />)

    return (
        <>
            <div className="geoSort">
                <div className={'numberOfUsers'}>
                    <div className="numberOfUsers">{userList.length}</div>
                    <p>
                        {t('Users in table', {
                            postProcess: 'interval',
                            count: getPlural(userList.length, i18next.language)
                        })}
                    </p>
                </div>
                {/*<p>{t('Sort by')}</p>*/}
                <Formik
                    initialValues={formInitialValues}
                    onSubmit={(values) => {
                        setCurrentOrder(values.sort)
                    }}
                >
                    <Form>
                        <Field name="sort">
                            {({ field, form }: FieldProps) => (
                                <SelectField
                                    options={orderOptions}
                                    field={field}
                                    form={form}
                                    label={t('Sort by')}
                                    onChangeCallback={() => form.handleSubmit()}
                                />
                            )}
                        </Field>
                    </Form>
                </Formik>
            </div>
            {!loggedIn && <p className={'tableDisclaimer'}>{t('Login to estimate distances')}</p>}
            {loggedIn && filters.shareMyLocation === 0 && !hidePosition && (
                <p className={'tableDisclaimer'}>{t('Share your position on the map to estimate distances')}</p>
            )}
            {loggedIn && hidePosition && (
                <p className={'tableDisclaimer'}>
                    {t('Enable geolocation in your browser settings to estimate distances')}
                </p>
            )}
            {userListOut}
        </>
    )
}

export default GeoUserList
